import { useEffect, useState } from "react";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { ModalRowContentContainer } from "../../../AlimTalk/AlimTalkModal";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";
import { Input } from "../../../../Input/Input";
import { useApi } from "../../../../../hooks/useApi";
import { toast } from "react-toastify";
import Loader from "../../../../DefaultStyles/Loader";
import { encryptPW } from "../../../../../ApiTS/ApiCommonTS";
import RadioBtn from "../../../../Button/RadioBtn";

interface Props extends DefaultModalCommonProps {
  partyId: number;
  uid: number;
  email: string;
  linkidmail?: string;
}

export default function NetflixExtraPwRegisterModal({
  closeEvent,
  confirmEvent,
  partyId,
  uid,
  email,
  linkidmail,
}: Props) {
  const [reset, setReset] = useState(false);

  const [password, setPassword] = useState("");

  const [SelectedMail, setSelectedMail] = useState(email);

  const { response, loading, error } = useApi({
    method: "post",
    url: reset ? `party/${partyId}/extraPw/${uid}` : "",
    data: {
      email: SelectedMail,
      pw: encryptPW(password, uid),
    },
  });

  useEffect(() => {
    if (response?.status === 201) {
      toast.success("비밀번호가 등록 되었습니다.");
      if (confirmEvent) confirmEvent();
      closeEvent();
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "비밀번호 재설정에 실패했습니다.");
      setReset(false);
    }
  }, [error]);

  const showLinkidEmail = () => {
    if (linkidmail !== email) {
      return (
        <>
          <ModalRow style={{ alignItems: "flex-start" }}>
            <ModalLabel>링키드 이메일</ModalLabel>
            <RadioBtn
              // label="해당 없음"
              check={SelectedMail === linkidmail}
              clickEvent={() => setSelectedMail(linkidmail!)}
              noTooltip
              sHeight={38}
              disabled={false}
            />
            <ModalRowContentContainer style={{ flex: 1 }}>
              <ModalLabel>{linkidmail === "" ? "없음" : linkidmail}</ModalLabel>
            </ModalRowContentContainer>
          </ModalRow>
        </>
      );
    } else {
      return <></>;
    }
  };
  console.log(SelectedMail);

  return (
    <DefaultModalLayout
      closeEvent={closeEvent}
      confirmEvent={() => {
        setReset(true);
      }}
      isMediumModal
      modalTitle="비밀번호 등록하기"
      confirmDisabled={password === ""}
    >
      <ModalRow style={{ alignItems: "flex-start" }}>
        <ModalLabel>현재 계정</ModalLabel>
        <RadioBtn
          // label="해당 없음"
          check={SelectedMail === email}
          clickEvent={() => setSelectedMail(email!)}
          noTooltip
          sHeight={38}
          disabled={false}
        />
        <ModalRowContentContainer style={{ flex: 1 }}>
          <ModalLabel>{email}</ModalLabel>
        </ModalRowContentContainer>
      </ModalRow>

      {showLinkidEmail()}

      <ModalRow style={{ alignItems: "flex-start" }}>
        <ModalLabel>비밀번호</ModalLabel>

        <ModalRowContentContainer style={{ flexWrap: "wrap" }}>
          <Input
            placeholder="비밀번호를 입력해 주세요"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </ModalRowContentContainer>
      </ModalRow>

      <>{loading && <Loader />}</>
    </DefaultModalLayout>
  );
}
